import { forwardRef, HTMLProps, ReactNode, useEffect } from "react";
import { Portal } from "@headlessui/react";
import { classNames } from "../utils/classNames";
import { toZIndex, ZLayer } from "./config";

let overlays = 0;

export type FloatingOverlayProps = {
  /** if true, put up a full "glass pane" that blocks interactions on elements in the background */
  modal?: boolean;
  layer?: ZLayer;
  children: ReactNode;
  onUnmount?: () => void;
} & HTMLProps<HTMLDivElement>;

export const FloatingOverlay = forwardRef<HTMLDivElement, FloatingOverlayProps>(
  function FloatingOverlay({ modal, layer, children, className, style, onUnmount, ...props }, ref) {
    useEffect(() => {
      if (modal) {
        overlays++;
        document.body.classList.toggle("tw-overflow-hidden", true);
        return () => {
          overlays = Math.max(0, overlays - 1);
          if (overlays === 0) {
            document.body.classList.remove("tw-overflow-hidden");
          }
        };
      }
    }, [modal]);

    useEffect(() => {
      return onUnmount;
    }, [onUnmount]);

    return (
      <Portal ref={ref}>
        <div
          {...props}
          className={classNames(
            modal ? "tw-fixed tw-overflow-auto tw-inset-0" : "tw-absolute",
            className,
          )}
          style={{
            zIndex: layer ? toZIndex(layer) : undefined,
            ...style,
          }}
        >
          {children}
        </div>
      </Portal>
    );
  },
);
